<template>
  <div class="content">
    <template >
      <div class="table-page-search-wrapper search-bt">
        <a-form layout="inline" :labelCol="{ style: { width: '130px' } }">
          <a-row>
            <a-col :md="6" :sm="24">
              <a-form-item label="版本">
                <global-select
                  @change="handleVersionChange"
                  :value.sync="queryParams.versionCode"
                  selectType="select"
                  :setParams="{ id: queryParams.sopDfcBasicDataId }"
                  requestApi="/scp/scpSopDfcBasicData/versionList"
                  :selectItem="{ value: 'selectedValue', label: 'label' }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="说明">
                <a-input :disabled="true" v-model="queryParams.description"></a-input>
              </a-form-item>
            </a-col>
            <template v-if="advanced" >
              <a-col :md="6" :sm="24">
                <a-form-item label="事业部">
                  <global-select
                    :max-tag-count="2"
                    :max-tag-text-length="4"
                    show-search
                    :value.sync="queryParams.businessUnit"
                    :dropdown-match-select-width="false"
                    selectType="selectFilter"
                    :selectData="businessUnitList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced && (showFalg1 || showFalg2)">
              <a-col :md="6" :sm="24">
                <a-form-item label="软货标签及快递类型">
                  <global-select
                    :max-tag-count="2"
                    :max-tag-text-length="4"
                    show-search
                    :value.sync="queryParams.sopSoftGoodsLabelExpressType"
                    :dropdown-match-select-width="false"
                    selectType="selectFilter"
                    :selectData="sopSoftGoodsLabelExpressTypeList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced && showFalg2">
              <a-col :md="6" :sm="24">
                <a-form-item label="发货月">
                  <global-select
                    :max-tag-count="2"
                    :max-tag-text-length="4"
                    show-search
                    :value.sync="queryParams.deliveryDate"
                    :dropdown-match-select-width="false"
                    selectType="selectFilter"
                    :selectData="deliveryDateList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced && showFalg3">
              <a-col :md="6" :sm="24">
                <a-form-item label="报表参数">
                  <global-select
                    :max-tag-count="2"
                    :max-tag-text-length="4"
                    show-search
                    :value.sync="queryParams.reportParameters"
                    :dropdown-match-select-width="false"
                    selectType="selectFilter"
                    :selectData="reportParametersList"
                    :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
                <a-button @click="resetQuery" class="ml8">重置</a-button>
                <a @click="toggleAdvanced" class="ml8">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </template>
    <template>
      <a-tabs class="content-tabs" type="card" @change="callback">
        <a-tab-pane key="1" tab="期初发货比例">
          <begin-info-table ref="BeginInfoTable" :id="queryParams.sopDfcBasicDataId"></begin-info-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="历史发货比例">
          <history-info-table ref="HistoryInfoTable" :id="queryParams.sopDfcBasicDataId"></history-info-table>
        </a-tab-pane>
        <a-tab-pane key="3" tab="滚动业绩报表">
          <earning-report-table ref="EarningReportTable" :id="queryParams.sopDfcBasicDataId"></earning-report-table >
        </a-tab-pane>
      </a-tabs>
    </template>
  </div>
</template>
<script>
  import BeginInfoTable from './components/BeginInfoTable'
  import HistoryInfoTable from './components/HistoryInfoTable'
  import EarningReportTable from './components/EarningReportTable'

export default {
  // eslint-disable-next-line
  name: 'versionDetail', // name要和菜单路由保存一致
  components: {
    BeginInfoTable,
    HistoryInfoTable,
    EarningReportTable
  },
  data () {
    return {
      timer: null,
      // 控制搜索展开
      advanced: true,
      showFalg1: true,
      showFalg2: false,
      showFalg3: false,
      businessUnitList: [], // 事业部
      sopSoftGoodsLabelExpressTypeList: [], // 软货标签及快递类型
      deliveryDateList: [], // 发货月
      reportParametersList: [], // 报表参数
      // 查询参数
      queryParams: {
        sopDfcBasicDataId: undefined,
        businessUnit: undefined,
        sopSoftGoodsLabelExpressType: undefined,
        deliveryDate: undefined,
        reportParameters: undefined,
        description: undefined,
        versionCode: undefined
      }
    }
  },
  methods: {
    onSearch () {
     if (this.$refs.BeginInfoTable) {
      this.$refs.BeginInfoTable.onSearch(this.queryParams)
     }
     if (this.$refs.HistoryInfoTable) {
      this.$refs.HistoryInfoTable.onSearch(this.queryParams)
     }
     if (this.$refs.EarningReportTable) {
      this.$refs.EarningReportTable.onSearch(this.queryParams)
     }
    },
    handleVersionChange (val, list) {
      if (val) {
        const filteredObject = list.filter(obj => obj.selectedValue === val);
        console.log(5555);
        this.queryParams.sopDfcBasicDataId = filteredObject[0].selectedValue
        this.queryParams.versionCode = filteredObject[0].label
        this.queryParams.description = filteredObject[0].realValue
        this.sopDfcBasicDataId = this.queryParams.sopDfcBasicDataId;
        this.versionCode = this.queryParams.versionCode;
        this.description = this.queryParams.description;
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
        this.advanced = !this.advanced
      },
      getLookupList (type, arr, code) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
        if (code === 'businessUnitList') {
          this[arr] = this[arr].filter(item => item.attribute1 === null); // 只显示attribute1为""的
        }
      })
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          sopDfcBasicDataId: this.sopDfcBasicDataId,
          versionCode: this.versionCode,
          description: this.description,
          businessUnit: undefined,
          sopSoftGoodsLabelExpressType: undefined,
          deliveryDate: undefined,
          reportParameters: undefined
        }
        this.onSearch()
      },
    callback (key) {
      if (key === "1") {
        this.showFalg1 = true;
        this.showFalg2 = false;
        this.showFalg3 = false;
        this.queryParams.deliveryDate = undefined;
        this.queryParams.reportParameters = undefined;
      } else if (key === "2") {
        this.showFalg1 = false;
        this.showFalg2 = true;
        this.showFalg3 = false;
        this.queryParams.reportParameters = undefined;
      } else if (key === "3") {
        this.showFalg1 = false;
        this.showFalg2 = false;
        this.showFalg3 = true;
        this.queryParams.sopSoftGoodsLabelExpressType = undefined;
      }
      console.log(key)
    }
  },
    created () {
        this.showFalg1 = true;
        this.queryParams.sopDfcBasicDataId = this.$route.query.id; // 从路由参数中获取 id 值
        this.queryParams.description = this.$route.query.description; // 从路由参数中获取 id 值
        this.queryParams.versionCode = this.$route.query.versionCode; // 从路由参数中获取 id 值
        this.sopDfcBasicDataId = this.queryParams.sopDfcBasicDataId;
        this.versionCode = this.queryParams.versionCode;
        this.description = this.queryParams.description;
        this.getLookupList('SCP_BUSINESS_UNIT', 'businessUnitList', 'businessUnitList');
        this.getLookupList('SCP_SOFT_GOODS_LABEL_EXPRESS_TYPE', 'sopSoftGoodsLabelExpressTypeList', '');
        this.getLookupList('SCP_DELIVERY_DATE', 'deliveryDateList', '');
        this.getLookupList('SCP_REPORT_PARAMETERS', 'reportParametersList', '');
    },
    mounted () {
     this.onSearch(this.queryParams)
    }
}
</script>
<style lang="less" scoped>
.content{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}.search-bt{
    background-color: white;
    padding: 8px;
    margin-bottom: 8px;
}.content-tabs{
    background-color: white;
    width: 100%;
    flex:1;
    padding: 8px;
}.ml8{
  margin-left: 8px
}
</style>
